import { EmptyState } from '@app/components/base/EmptyState';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import { Box, CircularProgress } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const noStationsTitleMessage = defineMessage({
  id: 'common.noStations.title',
  defaultMessage: 'No hay emisoras asignadas aún',
});

const noStationsHelpMessage = defineMessage({
  id: 'common.noStations.message',
  defaultMessage: 'Esta pantalla se actualizará automáticamente cuando estén disponibles.',
});

/**
 * Empty state shown in the main content area when the authenticated user has no
 * stations assigned. The app shell (sidenav) remains visible around this page.
 */
export function NoStationsPage() {
  return (
    <EmptyState
      icon={SensorsOffIcon}
      message={<FormattedMessage {...noStationsTitleMessage} />}
      help={<FormattedMessage {...noStationsHelpMessage} />}
      action={
        <Box sx={{ opacity: 0.5 }}>
          <CircularProgress size={24} />
        </Box>
      }
      centered
    />
  );
}
